import './index.less';

import classNames from 'classnames';
import { ComponentProps, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import SynTitleTabs from '@/components/Tabs/SynTitleTabs';
import { DAPP_CHAIN_CONFIGS } from '@/constants/chain';
import { EARN_TYPE } from '@/constants/earn';
import { TRADE_TYPE } from '@/constants/trade';
import { resetLiquidityFormByChainId, setEarnFormType } from '@/features/earn/action';
import { resetFormByChainId, setTradeFormType } from '@/features/trade/actions';
import { useAppDispatch } from '@/hooks';
import { useChainId } from '@/hooks/web3/useChain';
type TradeEarnTabsProps = ComponentProps<'div'> & {
  isTrade: boolean;
  pairSymbol?: string;
  disableTrade?: boolean;
};
export default function TradeEarnTabs({ isTrade, pairSymbol, disableTrade = false }: TradeEarnTabsProps) {
  const chainId = useChainId();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const tabItems = useMemo(
    () => [
      {
        key: 'trade',
        label: t('common.trade'),
      },
      {
        key: 'earn',
        label: t('common.liquidity'),
      },
    ],
    [t],
  );

  const handleTabClick = (key: string) => {
    if (key === 'trade') {
      if (disableTrade) return;
      chainId && dispatch(resetLiquidityFormByChainId({ chainId }));
      chainId && dispatch(setTradeFormType({ chainId, tradeType: TRADE_TYPE.MARKET }));
      const url =
        (chainId && pairSymbol && `/trade/${DAPP_CHAIN_CONFIGS[chainId]?.network?.shortName}/${pairSymbol}`) || '';
      if (url) navigate(url);
    } else if (key === 'earn') {
      chainId && dispatch(resetFormByChainId({ chainId }));
      chainId && dispatch(setEarnFormType({ chainId, formType: EARN_TYPE.ADD_LIQ }));
      const url =
        (chainId && pairSymbol && `/earn/${DAPP_CHAIN_CONFIGS[chainId]?.network?.shortName}/${pairSymbol}`) || '';
      if (url) navigate(url);
    }
  };

  return (
    <div className={classNames('syn-trade-earn-tabs', isTrade ? 'trade' : 'earn')}>
      <SynTitleTabs
        className="syn-trade-earn-tabs-content"
        items={tabItems}
        activeKey={isTrade ? 'trade' : 'earn'}
        onClick={handleTabClick}
      />
    </div>
  );
}
